export function clockTemplate(el) {
  const children = el.children
  const a = children[0]
  const span = children[1]
  const p = children[2]
  return itemTpl(
    {
      advert_url: a.getAttribute('data-url'),
      id: a.getAttribute('data-id'),
      flag: a.getAttribute('data-flag')
    },
    span.innerHTML,
    p.innerHTML
  )
}

function itemTpl(item, sHtml, pHtml) {
  const wxOpenInWeapp = document.querySelector('.wxOpenInWeapp')
  const height = wxOpenInWeapp.offsetHeight
  const width = wxOpenInWeapp.offsetWidth
  return `
    <div
      style="height: ${height}px;width: ${width}px"
      data-url='${item.advert_url}'
      data-id='${item.id}'
      data-flag='${item.flag}'
      data-json='${escape(JSON.stringify(item))}'
    >
      <span class="tips">${sHtml}</span>
      <p class="nav-desc">${pHtml}</p>
      <div class="info">打卡作业</div>
    </div>
  `
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/clock/tpl.js